import React, { Suspense, lazy } from 'react';
import { LoaderFallback } from '../../../shared/LoaderFallback/LoaderFallback';
import { useAppDispatch } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { Subwindow } from '../../Subwindow/Subwindow';

const Features = lazy(() => import('../../../features/LauncherConfiguration/Features/Features'));
const MemoizedFeatures = React.memo(Features);

export const FeaturesPanel = () => {
    const { t, i18n } = useTranslation();

    return (
        <Subwindow
            isRelative={true}
            hasProjectPath={false}
            headerSettings={false}
            hasManu = {false}
            isSingle={false}
            title={t('titles.features')}
            headerMenu={
                <>
                </>
            }
            main={
            <Suspense fallback={<LoaderFallback color={'accent-green'} label={'Creating configuration tools'} />}>
                <MemoizedFeatures />
            </Suspense>
            }
            footer={<></>}
        />
    );
};
